import { render } from "./CerimoniaReligiosa.vue?vue&type=template&id=56bf2ffb&scoped=true"
import script from "./CerimoniaReligiosa.vue?vue&type=script&lang=js"
export * from "./CerimoniaReligiosa.vue?vue&type=script&lang=js"

import "./CerimoniaReligiosa.vue?vue&type=style&index=0&id=56bf2ffb&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-56bf2ffb"

export default script